import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const discards: ImportTypeConfig = {
  type: 'discards',
}
